import { HYDRATE_STATE } from "commons/src/reducers/indexActions";
import { SUCCESSFUL_LOGIN } from "commons/src/reducers/clientPortalUserActions";

import { SET_MSG, AUTH_START, AUTH_FINISH, AUTH_FAILED } from "./applicationContextActions";

export const applicationContext = (
    state = {
        isLoading: false,
        errorCode: null
    },
    action
) => {
    switch (action.type) {
        // firstLogin hard coded to false until NUDEV-4083
        case SUCCESSFUL_LOGIN: {
            return {
                ...state,
                firstLogin: false,
                isLoading: false,
                isError: false,
                errorCode: null,
                msg: null,
                msgSeverity: null,
                failedLogIn: false
            };
        }

        case AUTH_START:
            return {
                ...state,
                isLoading: true,
                isLoggedIn: false,
                errorCode: null,
                msg: null,
                msgSeverity: null
            };

        case AUTH_FINISH:
            return {
                ...state,
                isLoading: false
            };

        case AUTH_FAILED:
            return {
                ...state,
                isLoading: false,
                isLoggedIn: false,
                isError: true,
                errorCode: state.errorCode || action.errorCode,
                failedLogIn: action.failedLogIn
            };

        case SET_MSG:
            return {
                ...state,
                msg: action.msg,
                msgSeverity: action.severity,
                errorCode: state.errorCode || action.errorCode || null,
                isFatal: action.isFatal,
                failedLogIn: state.failedLogIn || false
            };

        case HYDRATE_STATE:
            return { ...state, ...action.newState.applicationContext };

        default:
            return state;
    }
};
